function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckboxRound48 = function SvgCheckboxRound48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#231f20",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    d: "m17.5 24.3 4.1 4.1 7.7-7.7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24.7,
    r: 17.5,
    style: {
      fill: "none",
      stroke: "#231f20",
      strokeMiterlimit: 10
    }
  }));
};
export default SvgCheckboxRound48;